
import { Options, Vue } from 'vue-class-component';
import Waiting from '@common/components/Utils/Waiting.vue';
import SignaturePageRepository, { SignaturePageError } from '@signature/plugins/Api/SignaturePageRepository';
import { isSandbox, openSignature } from '@signature/tools/YousignIframe';

const RETRY_DELAY = 5000;

@Options({
  components: { Waiting },
})
export default class App extends Vue {
  private signers: SignaturePageSignerInterface[] = [];

  private current = 0;

  private loading = true;

  private notice = '';

  private error = '';

  private contactAdvisor = false;

  private retry: ReturnType<typeof setTimeout>|null = null;

  mounted() {
    this.load();
  }

  unmounted() {
    if (this.retry) {
      clearTimeout(this.retry);
    }
  }

  private get link(): { type: string; uuid: string; token: string }|null {
    const [type, uuid, token] = window.location.pathname.split('/').filter(Boolean);

    return type && uuid && token ? { type, uuid, token } : null;
  }

  private load() {
    if (!this.link) {
      this.fail(this.translate('signature-link-incomplete'));

      return;
    }

    SignaturePageRepository.get(this.link.type, this.link.uuid, this.link.token)
      .then((signers: SignaturePageSignerInterface[]) => {
        if (!signers.length) {
          this.fail(this.translate('signature-not-found'), true);

          return;
        }
        this.signers = signers;
        this.loading = false;
        this.$nextTick(() => this.open());
      })
      .catch((error: SignaturePageError) => {
        if (error.status === 503) {
          this.notice = this.translate('signature-being-prepared');
          this.retry = setTimeout(() => this.load(), RETRY_DELAY);

          return;
        }
        this.fail(error.message || this.translate('signature-not-found'), error.status === 403);
      });
  }

  private select(index: number) {
    this.current = index;
    this.open();
  }

  private open() {
    openSignature('yousign-container', this.signers[this.current].signatureLink, isSandbox())
      .catch(() => this.fail(this.translate('signature-module-unavailable')));
  }

  private fail(message: string, contactAdvisor = false) {
    this.loading = false;
    this.error = message;
    this.contactAdvisor = contactAdvisor;
  }
}
